import {
  MUTATION_RESPONSE_RECEIVED,
  QUERY_RESPONSE_RECEIVED,
} from '@web-platform/shared-universal-constants/src/network';
import * as persistanceKeys from '@web-platform/shared-universal-constants/src/persistanceKeys';
import { MULTI_DESTINATION } from '@web-platform/shared-universal-constants/src/tripTypes';
import { getIsMultiDestination } from '@web-platform/shared-universal-translations';
import {
  RADAR_CREATE_SESSIONS,
  RADAR_POLL,
} from '@web-platform/shared-universal-types/src/network/requestTypes';
import { isResponseContainFlightsBody } from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/flightsResponse';
import {
  getRadarFlightsResponseBody,
  isRadarFlightsResponseError,
} from '@web-platform/shared-universal-utils-frontend/src/helpers/radar/radarFlightsResponse';
import { tryGetValue } from '@web-platform/shared-universal-utils-frontend/src/helpers/sessionStorage';

import { FILTERS_RESET, MIXED_AIRPORT_FILTER_CHANGED } from '../../../../../../actions/filters';

import { mapMixedAirport } from './mixedAirportMapper';

import type { Action } from '@web-platform/shared-universal-types/src/redux/banana/actions/actions-banana-types';
import type { MixedAirportFilterState } from '@web-platform/shared-universal-types/src/redux/state/flightSearchResults/features/filters/mixedAirport';

export const INITIAL_STATE = {
  visible: false,
  value: null,
};

const filtersInSession = (): MixedAirportFilterState => {
  const mixedAirportFromSession =
    // We don't want to use the mixedAirport filter on multi-city
    getIsMultiDestination() === MULTI_DESTINATION
      ? null
      : tryGetValue(persistanceKeys.FILTERS, { mixedAirport: INITIAL_STATE })?.mixedAirport;
  return mixedAirportFromSession && Object.keys(mixedAirportFromSession).length
    ? { ...mixedAirportFromSession, visible: false } // visible comes from Radar - not something we want to restore
    : INITIAL_STATE;
};
const mixedAirport = (
  state: MixedAirportFilterState = filtersInSession(),
  action: Action,
): MixedAirportFilterState => {
  switch (action.type) {
    case MUTATION_RESPONSE_RECEIVED:
    case QUERY_RESPONSE_RECEIVED: {
      switch (action.payload.type) {
        case RADAR_CREATE_SESSIONS:
        case RADAR_POLL: {
          if (
            isRadarFlightsResponseError(action.payload.response) ||
            !isResponseContainFlightsBody(action.payload.response)
          ) {
            return state;
          }

          const flightsResponseBody = getRadarFlightsResponseBody(action.payload.response);
          const stats = mapMixedAirport(flightsResponseBody.filterStats);

          if (!stats) return state;
          const { itineraries } = stats;
          const { has_city_open_jaw: hasCityOpenJaw } = itineraries;

          return {
            visible: hasCityOpenJaw || false,
            value: state.value !== null ? state.value : null,
          };
        }

        default: {
          return state;
        }
      }
    }

    case MIXED_AIRPORT_FILTER_CHANGED:
      return {
        visible: state.visible,
        value: action.payload.value,
      };

    case FILTERS_RESET:
      return { ...INITIAL_STATE, visible: state.visible };

    default:
      return state;
  }
};

export const get = (state: MixedAirportFilterState): MixedAirportFilterState => state;
export default mixedAirport;
